// src/DiscrepancyModal.js

import React from 'react';
import moment from 'moment';
import 'moment/locale/it';

moment.locale('it');

// Funzione helper per formattare la durata in ore e minuti
const formatDuration = (minutes) => {
    const duration = moment.duration(Math.abs(minutes), 'minutes');
    const hours = Math.floor(duration.asHours());
    const mins = duration.minutes();
    return `${hours > 0 ? `${hours} or${hours > 1 ? 'e' : 'a'}` : ''} ${mins > 0 ? `${mins} minut${mins > 1 ? 'i' : 'o'}`: ''}`.trim();
};

export function DiscrepancyModal({
    isOpen,
    onClose,
    timeDifferenceMinutes, // Differenza in minuti (positiva per eccesso, negativa per difetto)
    isManager,             // Flag booleano
    onAddOvertime,         // Funzione per aprire modale straordinario (o aggiungerlo)
    onRequestLeave,        // Funzione per aprire modale richiesta permesso
    // Aggiungi onAddLeave se il manager può aggiungere permesso direttamente
    // onAddLeave
}) {
    if (!isOpen) return null;

    const isOvertime = timeDifferenceMinutes > 0;
    const formattedDifference = formatDuration(timeDifferenceMinutes);

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()} style={{ maxWidth: '480px' }}>
                <h3> Rilevata Discrepanza Oraria</h3>
                <p style={{ fontSize: '1.1rem', margin: '20px 0' }}>
                    Hai lavorato circa <strong>{formattedDifference}</strong> in {isOvertime ? 'più' : 'meno'} rispetto al previsto.
                </p>

                {/* --- Logica Pulsanti --- */}
                {isOvertime ? (
                    // CASO ORE IN PIÙ (Straordinario)
                    <div>
                        <p>Vuoi registrare questo tempo come straordinario?</p>
                        <button
                            onClick={onAddOvertime} // Chiama la funzione passata
                            className="modal-button confirm-button"
                        >
                            {isManager ? 'Aggiungi Straordinario' : 'Registra Straordinario'}
                        </button>
                        <button onClick={onClose} className="modal-button cancel-button">
                            Ignora
                        </button>
                    </div>
                ) : (
                    // CASO ORE IN MENO (Permesso)
                    <div>
                        <p>Vuoi giustificare questo tempo come permesso?</p>
                        {isManager ? (
                            // Pulsanti Manager
                            <>
                                <button
                                     // Dovresti passare una funzione specifica onAddLeave se vuoi aggiungerlo direttamente
                                     // onClick={onAddLeave} // Esempio
                                     // Per ora, apriamo comunque il modale richiesta per coerenza
                                     onClick={onRequestLeave}
                                    className="modal-button confirm-button"
                                >
                                    Aggiungi Permesso
                                </button>
                                <button onClick={onClose} className="modal-button cancel-button">
                                    Ignora
                                </button>
                            </>
                        ) : (
                            // Pulsanti Utente Normale
                            <>
                                <button
                                    onClick={onRequestLeave} // Chiama la funzione passata
                                    className="modal-button confirm-button"
                                >
                                    Richiedi Permesso
                                </button>
                                <button onClick={onClose} className="modal-button cancel-button">
                                    Ignora
                                </button>
                            </>
                        )}
                    </div>
                )}
                 {/* --- Fine Logica Pulsanti --- */}

            </div>
        </div>
    );
}